import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import { queryKeys } from './useAuctions';

export function useUserReviews(userId: string | undefined) {
  return useQuery({
    queryKey: ['user-reviews', userId ?? ''],
    queryFn: () => api.listUserReviews(userId!),
    enabled: !!userId,
    staleTime: 60_000,
  });
}

export function useCreateReview(auctionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ rating, comment }: { rating: number; comment: string | null }) =>
      api.createReview(auctionId, rating, comment),
    onSuccess: () => {
      // Деталка изменилась (my_review теперь есть) — перечитаем
      qc.invalidateQueries({ queryKey: queryKeys.auction(auctionId) });
    },
  });
}